import { useEffect, useState } from 'react';
import { getSiteBilgileri } from '../services/api';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL !== undefined ? process.env.REACT_APP_BACKEND_URL : 'http://localhost:8000';

function useSEO() {
  const [ayar, setAyar] = useState(null);

  useEffect(() => {
    getSiteBilgileri().then(res => {
      const data = res.data;
      setAyar(data);

      // Title
      if (data.site_baslik) {
        document.title = data.site_baslik;
      }

      // Meta Description
      updateMeta('description', data.meta_description);

      // Meta Keywords
      if (data.meta_keywords) {
        updateMeta('keywords', data.meta_keywords);
      }

      // Open Graph tags
      updateMeta('og:title', data.site_baslik, 'property');
      updateMeta('og:description', data.meta_description, 'property');
      updateMeta('og:type', 'website', 'property');
      updateMeta('og:url', window.location.origin, 'property');
      if (data.og_image) {
        updateMeta('og:image', `${BACKEND_URL}${data.og_image}`, 'property');
      }

      // Twitter Card
      updateMeta('twitter:card', 'summary_large_image', 'name');
      updateMeta('twitter:title', data.site_baslik, 'name');
      updateMeta('twitter:description', data.meta_description, 'name');
      if (data.og_image) {
        updateMeta('twitter:image', `${BACKEND_URL}${data.og_image}`, 'name');
      }

      // Favicon
      if (data.favicon) {
        const faviconUrl = `${BACKEND_URL}${data.favicon}`;
        updateFavicon(faviconUrl);
      }

      // Google Analytics
      if (data.google_analytics_id) {
        loadGoogleAnalytics(data.google_analytics_id);
      }
    }).catch(() => {});
  }, []);

  return ayar;
}

function updateMeta(name, content, attr = 'name') {
  if (!content) return;
  let el = document.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function updateFavicon(url) {
  // Update existing favicon links
  const selectors = [
    'link[rel="icon"]',
    'link[rel="shortcut icon"]',
  ];
  selectors.forEach(sel => {
    let el = document.querySelector(sel);
    if (el) {
      el.href = url;
    }
  });

  // Also add a 32x32 icon if not present
  let icon32 = document.querySelector('link[rel="icon"][sizes="32x32"]');
  if (!icon32) {
    icon32 = document.createElement('link');
    icon32.rel = 'icon';
    icon32.sizes = '32x32';
    document.head.appendChild(icon32);
  }
  icon32.href = url;
}

function loadGoogleAnalytics(id) {
  if (!id || document.querySelector(`script[src*="googletagmanager"]`)) return;
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(script);

  const inlineScript = document.createElement('script');
  inlineScript.textContent = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${id}');
  `;
  document.head.appendChild(inlineScript);
}

export default useSEO;
